module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box viz"
  }, [_c('div', {
    staticClass: "panel-header panel-controls"
  }, [_c('h3', [_vm._v(_vm._s(_vm.component.name) + "  "), _c('button', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": function($event) {
        _vm.showControls = !_vm.showControls
      }
    }
  }, [(_vm.isEditable) ? _c('i', {
    staticClass: "fa fa-ellipsis-v"
  }) : _vm._e()])]), _vm._v(" "), (_vm.is_admin && _vm.isEditable) ? _c('div', {
    staticClass: "control-btn"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showControls),
      expression: "showControls"
    }],
    staticClass: "control-btn-submenu"
  }, [_c('ul', [(!_vm.component.corrupt) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.fetchRenderData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload")])]) : _vm._e(), _vm._v(" "), (!_vm.component.corrupt) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.editComponent
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v("  Edit")])]) : _vm._e(), _vm._v(" "), (!_vm.component.corrupt) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.cloneComponent
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v("  Clone")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.removeComponent
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove")])])])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-content chart-wrapper",
    class: {
      'plotly-chart': _vm.renderData.type == 'chart'
    }
  }, [(_vm.component.corrupt) ? _c('div', {
    staticClass: "corrupt-component"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("This widget could not be rendered, please remove it.")])]) : _c('viz-widget', {
    attrs: {
      "isLoading": _vm.loading,
      "chartId": _vm.component.id,
      "renderData": _vm.renderData,
      "height": _vm.height,
      "width": _vm.width
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-ban fa-3x fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f02ee30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ComponentBox.vue
// module id = 656
// module chunks = 0